
<template>
  <div class="tabs">
    <!-- tab 切换 -->
    <tab-nav
      :data="baseFormData"
      :selected="selected"
      :is-anchor="true"
      @change="tabNavChange"
    />
    <!-- 拒审记录 -->
    <reject-list
      v-if="permissionInfo && permissionInfo.is_show_rejects"
      :data="rejectData"
    />
    <!-- form 表单 -->
    <my-form
      v-if="!loading"
      ref="myForm"
      :data="baseFormData"
    />
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import TabNav from '@/components/pc/TabNav'
import RejectList from './RejectList'
import MyForm from './Form'

export default {
  components: {
    TabNav,
    MyForm,
    RejectList
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    formData: {
      type: Object,
      default: () => { }
    },
    rejectData: {
      type: [Object, Array],
      default: () => { }
    }
  },
  data () {
    return {
      selected: '',
      loading: false
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapGetters('inquery/detailData', ['memberInfo', 'permissionInfo']),
    inquiryInfoChild () { // 审核详情的人员信息
      const { childObj = {} } = this.memberInfo || {}

      const inputData = childObj.input || {}
      const auditData = childObj.audit || {}
      const devData = childObj.dev || {}
      const followData = childObj.follow || {}

      let auditTrueName = auditData.info && auditData.info.truename
      if (auditData.info && (auditData.info.status === 0 || auditData.info.status === -1)) { // 待审核
        auditTrueName = this.baseinfo && this.baseinfo.truename
      }

      const inputObj = {
        ...inputData,
        fieldvalue: (inputData.info && inputData.info.truename) || '- -'
      }
      const auditNameObj = {
        ...auditData,
        fieldkey: 'auditName',
        fieldvalue: auditTrueName || '- -'
      }
      const groupObj = {
        fieldkey: 'group',
        key: 'audit',
        fieldname: this.$t('message["1159"]'),
        fieldtype: 'cascader',
        fieldvalue: [],
        isneeded: 1,
        info: auditData.info
      }
      let devObj = {
        ...devData,
        key: 'dev',
        fieldtype: 'cascader',
        fieldvalue: []
      }

      let followObj = {
        ...followData,
        key: 'follow',
        fieldtype: 'cascader',
        fieldvalue: []
      }

      let data = [inputObj, auditNameObj, groupObj, devObj, followObj]

      if (this.permissionInfo.is_show_approval === 0 && this.permissionInfo.is_show_reapproval === 0) {
        devObj.fieldtype = 'string'
        followObj.fieldtype = 'string'
        data = [inputObj, devObj, followObj]
      }

      return data
    },
    baseFormData () {
      if (!this.formData) return
      const { info: inquiryInfo = {} } = this.formData || {}
      const data = {
        ...this.formData,
        info: {
          ...inquiryInfo,
          child: this.inquiryInfoChild,
          show: true
        }
      }
      return this.sortObj(data)
    },
    isClue () {
      return this.$route.name === 'ClueDetail'
    }
  },
  /* watch: {
    formData: {
      handler (val) {
        const { base_info: baseInfo = {} } = val || {}

        if (!baseInfo || !baseInfo.child || !val.deal_info) return

        for (let i in val) {
          let item = val[i]
          if (item.child && item.child.length) {
            this.$set(item, 'show', true)
          }
        }

        const infoStatus = baseInfo.child.find(
          item => item.fieldkey === 'info_status'
        )

        if (!infoStatus || !infoStatus.options) return

        const dealStatusItem = infoStatus.options.find(
          item => item.name === this.$t('message["109"]')
        ) || {}
        const res = dealStatusItem.id === infoStatus.fieldvalue

        this.$set(val.deal_info, 'show', res)
      },
      immediate: true
    }
  }, */
  created () {
    const { formData = {} } = this
    const { base_info: baseInfo = {}, demand_info: demandInfo = {}, contact_info: contactInfo = {} } = formData
    this.selected = this.isClue ? (demandInfo.fieldkey || contactInfo.fieldkey) : baseInfo.fieldkey
  },
  methods: {
    ...mapActions('inquery/relateData', ['fetchRelateTeamInfo']),
    tabNavChange (k, ev) {
      this.selected = k
    },
    /**
     * 将对象根据某一数字键进行排序,防止在Safari上自动根据【sort】排序
     * @param {Object} data 原始为排序的对象
     * @param {String} key 排序参考数字键
     * @return {Object}
     */
    sortObj (data, key = 'sort') {
      let aData = []
      let snapData = []
      let result = {}
      for (let k in data) {
        let item = data[k]
        if (k === 'audit_info') {
          continue
        }
        /* if ('sort' in item) {
          aData[item.sort - 1] = item
        } else {
          snapData.push(item)
        } */
        snapData.push(item)
      }
      aData = aData.concat(snapData)
      for (let i = 0; i < aData.length; i++) {
        let item = aData[i] || {}
        if (item && 'fieldkey' in item && item.child && item.child.length) {
          result[item.fieldkey] = item
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
